import List from "./components/List";

const routes = {
  path: "dashboard/statistics-dashboard",
  children: [{ path: "", element: <List /> }],
};

export default routes;
